import React, { useEffect, useState } from "react"
import styles from "./chatBots.module.css"
import Button from "../../components/Form/Button"
import Table from "../../components/Table"
import { useNavigate, useParams } from "react-router-dom"
import Loading from "../layouts/Loading"
import api from "../../services/api"
import ModalNewFlow from "../../components/Modal/Flow/ModalNewFlow"
import { getOptionByOptionList } from "../../utils/utils"
import moment from "moment"
import BackButton from "../../components/BackButton"

const headers = [
    "#",
    "Nome",
    "Status",
    "Última Modificação",
    "",
]

const status = [
    { id: "DRAFT", value: "Rascunho" },
    { id: "ACTIVE", value: "Ativo" },
]

const ChatBots = () => {
    const [data, setData] = useState([])
    const [showModalNewFlow, setShowModalNewFlow] = useState(false)
    const [loading, setLoading] = useState(false)
    const { account_id } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        getAllFlows()
    }, [])

    const getAllFlows = () => {
        setLoading(true)
        api.get(`/flows/chatbots`).then(response => {
            const flows = response.data.data || []
            setData(flows.map(getDataByFlow))
        }).catch(err => console.log(err)).finally(() => setLoading(false))
    }

    const getDataByFlow = (flow) => {
        return {
            id: flow._id,
            value: [
                flow.name,
                getOptionByOptionList(flow.status, status),
                moment(flow.updated_at).format("DD/MM/YYYY HH:mm:ss"),
                <Button variant="primary">Acessar</Button>,
            ],
            path: getLinkByFlow(flow),
        }
    }

    const getLinkByFlow = (flow) => {
        return `/${account_id}/integrations/chat/chatbots/${flow._id}/preview`
    }

    const handleNavigateToPage = (id) => {
        data?.forEach(el => {
            if (el.id === id) {
                navigate(el.path)
            }
        })
    }

    const handleOpenModalNewFlow = () => {
        setShowModalNewFlow(true)
    }

    const handleCloseModalNewFlow = () => {
        setShowModalNewFlow(false)
    }

    const handleSaveNewFlow = (flow) => {
        setLoading(true)
        api.post(`/flows/chatbots`, flow).then(response => {
            const flow = response.data.data || {}
            if (flow) {
                const link = getLinkByFlow(flow)
                navigate(link)
            }
        }).catch(err => console.log(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    return (
        <div className={styles.container}>
            <div className="page-back-row">
                <BackButton fallback={`/${account_id}/integrations/chat`} />
            </div>
            <div className={styles.actions}>
                <Button variant="primary" onClick={handleOpenModalNewFlow}>Adicionar Fluxo</Button>
            </div>
            <Table
                headers={headers}
                values={data}
                onClick={(id) => handleNavigateToPage(id)}
                messageNotRegisters="Nenhum registro encontrado"
                showIndex={true}
            />
            {showModalNewFlow &&
                <ModalNewFlow
                    onSubmit={handleSaveNewFlow}
                    closeModal={handleCloseModalNewFlow}
                />
            }
            {loading && <Loading fullPage={true} />}
        </div>

    )
}

export default ChatBots
